import * as fromDatatype from "../datatype-library";

export interface bl_alg_cc_conversation_agent_squad_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  conversation_guid: fromDatatype.GuidDataFieldInterface;
  agent_guid: fromDatatype.GuidDataFieldInterface;
  squad_hdr_guid: fromDatatype.GuidDataFieldInterface;
  group_hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  link_priority: fromDatatype.IntegerDatatypeInterface;
  rank: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_alg_cc_conversation_agent_squad_link_RowClass
  implements bl_alg_cc_conversation_agent_squad_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  conversation_guid: fromDatatype.GuidDataFieldInterface;
  agent_guid: fromDatatype.GuidDataFieldInterface;
  squad_hdr_guid: fromDatatype.GuidDataFieldInterface;
  group_hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  link_priority: fromDatatype.IntegerDatatypeInterface;
  rank: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
